export default __webpack_public_path__ + "static/media/86a6d7c0430202327b1cc126c25b094d.png";